import {
  Paper,
  Grid,
  Button,
  Checkbox,
  FormGroup,
  Alert,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Stack,
  TextField,
} from "@mui/material";
import React, { useContext } from "react";

import constant from "../Costanti/Constant.js";
import "dayjs/locale/it";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useNavigate } from "react-router-dom";
import InfoUserAdmin from "../InfoUserAdmin";
import { Context } from "../Context.js";

const Utenze = {
  ADMIN: 1,
  USER: 2,
  OPERATORE: 5,
};

const NuovoAbbonamentoDaOperatore = () => {
  const { token, idTipoUtente } = useContext(Context);

  const [costoAbbonamento, setCostoAbbonamento] = React.useState("0");
  const [tipoAbbonamento, setTipoAbbonamento] = React.useState("");

  const [nomeNuovoUtente, setNomeNuovoUtente] = React.useState("");
  const [cognomeNuovoUtente, setCognomeNuovoUtente] = React.useState("");
  const [telefonoNuovoUtente, setTelefonoNuovoUtente] = React.useState("");
  const [emailNuovoUtente, setEmailNuovoUtente] = React.useState("");

  const [bookableField, setBookableField] = React.useState([]);
  const [selectedFields, _] = React.useState(new Set());
  const [isPagamentoContanti, setIsPagamentoContanti] = React.useState(false);
  const [num, setNum] = React.useState("0");
  const [alertError, setAlertError] = React.useState(false);
  const [alertOk, setAlertOk] = React.useState(false);

  const [DatePickerAnno, setDatePickerAnno] = React.useState(false);
  const [DatePickerMese, setDatePickerMese] = React.useState(false);
  const [DatePickerGiorno, setDatePickerGiorno] = React.useState(false);

  const [msgAlert, setMsgAlert] = React.useState("");
  const [valueData, setValueData] = React.useState(dayjs());

  const [visualizzaPagina, setVisualizzaPagina] = React.useState(false);
  const [isClickableButton, setIsClickableButton] = React.useState(true);

  const navigate = useNavigate();

  React.useEffect(() => {
    if (idTipoUtente != Utenze.ADMIN && idTipoUtente != Utenze.OPERATORE) {
      navigate("/");
    } else {
      setVisualizzaPagina(true);
    }
  }, []);

  React.useEffect(() => {
    richiestaCampi();
  }, []);

  const richiestaCampi = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append(
      "Access-Control-Allow-Headers",
      "Access-Control-Allow-Headers , X-Requested-With, Content-Type, Authorization"
    );
    myHeaders.append(
      "Access-Control-Allow-Methods",
      "PUT, GET, POST, DELETE, OPTIONS"
    );
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Pragma", "no-cache");
    myHeaders.append("Authorization", `Bearer ${token}`);

    fetch(constant.RICHIESTACAMPI, {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    })
      .then((response) => {
        if (!response.ok) {
          throw navigate("/");
        } else {
          return response.json();
        }
      })
      .then((fieldList) =>
        setBookableField(fieldList.map((field) => field["NomeCampo"]))
      )
      .catch((error) => console.log("error", error));
  };

  // === LOGICA: invariata ===
  const handleChange = (event) => {
    setCostoAbbonamento(event.target.value);
    if (event.target.name === "Annuale") {
      setTipoAbbonamento("Annuale");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
    if (event.target.name === "Mensile") {
      setTipoAbbonamento("Mensile");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
    if (event.target.name === "Trimestrale") {
      setTipoAbbonamento("Trimestrale");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
    if (event.target.name === "Giornaliero") {
      setTipoAbbonamento("Giornaliero");
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
  };

  const isBookableFieldChecked = (index) => {
    // ritorna un boolean, serve per il prop 'checked'
    return selectedFields.has(index + 1);
  };

  const checkBookableField = (event, index) => {
    if (event.target.checked) {
      selectedFields.add(index + 1);
    } else {
      selectedFields.delete(index + 1);
    }
    setNum(selectedFields.size);
  };

  const checkContanti = (event) => {
    setIsPagamentoContanti(!!event.target.checked);
  };

  const buttonCLickPagamento = () => {
    if (isPagamentoContanti) {
      if (nomeNuovoUtente === "") {
        setMsgAlert("Errore: è necessario inserire un nome valido");
        setAlertError(true);
        setAlertOk(false);
      } else if (cognomeNuovoUtente === "") {
        setMsgAlert("Errore: è necessario inserire un cognome valido");
        setAlertError(true);
        setAlertOk(false);
      } else if (telefonoNuovoUtente === "") {
        setMsgAlert(
          "Errore: è necessario inserire un numero di telefono valido"
        );
        setAlertError(true);
        setAlertOk(false);
      } else if (emailNuovoUtente === "") {
        setMsgAlert("Errore: è necessario inserire una email valida");
        setAlertError(true);
        setAlertOk(false);
      } else {
        buttonCLick();
      }
    } else {
      setMsgAlert("Errore: è necessario selezionare il pagamento in contanti");
      setAlertError(true);
      setAlertOk(false);
    }
  };

  const buttonCLick = () => {
    setIsClickableButton(false);
    let _dataInizioAbbonamento = "";
    let _dataFineAbbonamento = "";

    if (num == 0) {
      setMsgAlert("Errore: selezionare un abbonamento");
      setAlertError(true);
      setAlertOk(false);
      setIsClickableButton(true);
    } else {
      setAlertError(false);
      if (tipoAbbonamento === "Giornaliero") {
        let annoInizio = valueData.year().toString();
        let meseInizio = (valueData.month() + 1).toString();
        let giornoInizio = valueData.date().toString();

        if (meseInizio < 10) {
          meseInizio = `0${meseInizio}`;
        }
        if (giornoInizio < 10) {
          giornoInizio = `0${giornoInizio}`;
        }

        _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
        _dataFineAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}235959`;
      }

       if (tipoAbbonamento === "Mensile") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let meseFine = (valueData.month() + 2).toString();
      let giornoInizio = valueData.date().toString();

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (meseFine < 10) {
        meseFine = `0${meseFine}`;
      }

      if (giornoInizio < 10) {
        giornoInizio = `0${giornoInizio}`;
      }

      _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
      if (meseInizio === "02") {
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      } else if (
        meseInizio === "04" ||
        meseInizio === "06" ||
        meseInizio === "09" ||
        meseInizio === "11"
      ) {
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      } else {
        if (meseFine === "02" && giornoInizio > 28) {
          console.log(giornoInizio);
          giornoInizio = "28";
        } else if (
          (meseFine === "04" ||
            meseFine === "06" ||
            meseFine === "09" ||
            meseFine === "11") &&
          giornoInizio > 30
        ) {
          giornoInizio = "30";
        }
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      }
    }

      if (tipoAbbonamento === "Trimestrale") {
        // L'utente sceglie solo mese e anno -> imposto giorno 1
        const dataInizio = valueData;   // <-- primo giorno del mese scelto
      
        let annoInizio = dataInizio.year().toString();
        let meseInizio = (dataInizio.month() + 1).toString();
        let giornoInizio = dataInizio.date().toString();

        
      
        // Calcolo data di fine: 90 giorni dopo il primo giorno del mese
        const dataFine = dataInizio.add(3, "month");
      
        let annoFine = dataFine.year().toString();
        let meseFine = (dataFine.month() + 1).toString().padStart(2, "0");

        if (meseInizio < 10) {
          meseInizio = `0${meseInizio}`;
        }

        if (giornoInizio < 10) {
          giornoInizio = `0${giornoInizio}`;
        }

        // Data inizio (formato richiesto)
        _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;

        // console.log("mese fine prima dei controlli: " + meseFine);
        // console.log("giorno fine prima dei controlli: " + giornoFine);
        switch (meseFine) {
          case "02":
            if (giornoInizio > 28) giornoInizio = "28";
            break;
          case "04":
          case "06":
          case "09":
          case "11":
            if (giornoInizio > 30) giornoInizio = "30";
            break;
          default:
            if (giornoInizio > 31) giornoInizio = "31";
        }
        // Data fine (formato richiesto)
        console.log(`Data fine calcolata: ${annoFine}-${meseFine}-${giornoInizio}`);
        _dataFineAbbonamento = `${annoFine}${meseFine}${giornoInizio}235959`;
        console.log(`Data inizio: ${_dataInizioAbbonamento}, Data fine: ${_dataFineAbbonamento}`);
    }

      if (tipoAbbonamento === "Annuale") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let giornoInizio = valueData.date().toString();

      let annoFine = (valueData.year() + 1).toString();

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (giornoInizio < 10) {
        giornoInizio = `0${giornoInizio}`;
      }


      _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
      console.log(`Data inizio: ${_dataInizioAbbonamento}`);
      _dataFineAbbonamento = `${annoFine}${meseInizio}${giornoInizio}235959`;
      console.log(`Data fine prima dei controlli: ${_dataFineAbbonamento}`);
    }

      sendApiData(
        _dataInizioAbbonamento,
        _dataFineAbbonamento,
        tipoAbbonamento
      );
    }
  };

  const sendApiData = (dataInizioAbbonamento, dataFineAbbonamento) => {
    let arrayCampi = [];
    if (num === 2) {
      arrayCampi = [1, 2];
    } else {
      arrayCampi = [1];
    }

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    var hh = today.getHours();
    var min = today.getMinutes();
    var sec = today.getSeconds();

    if (hh < 10) hh = "0" + hh;
    if (min < 10) min = "0" + min;
    if (sec < 10) sec = "0" + sec;

    today = yyyy + mm + dd + hh + min + sec;

    let arrCampi = [...selectedFields];

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append(
      "Access-Control-Allow-Headers",
      "Access-Control-Allow-Headers , X-Requested-With, Content-Type, Authorization"
    );
    myHeaders.append(
      "Access-Control-Allow-Methods",
      "PUT, GET, POST, DELETE, OPTIONS"
    );
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Pragma", "no-cache");
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify({
        nome: nomeNuovoUtente,
        cognome: cognomeNuovoUtente,
        numeroTelefono: telefonoNuovoUtente,
        email: emailNuovoUtente,
        contante: isPagamentoContanti,
        idCampo: arrCampi,
        dataInizio: dataInizioAbbonamento,
        dataFine: dataFineAbbonamento,
        tipoAbbonamento: tipoAbbonamento,
        insDate: today,
        updDate: today,
      }),
    };

    fetch(constant.INSERTABBONAMENTOADMIN, requestOptions).then((response) => {
      return response.arrayBuffer().then(function (buffer) {
        const url = window.URL.createObjectURL(new Blob([buffer]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "qrCodeAbbonamento.png");
        document.body.appendChild(link);
        link.click();
        setMsgAlert("Abbonamento inserito correttamente");
        setAlertOk(true);
        setAlertError(false);
      });
    });
  };

  // ====== RENDER: GEMELLA GRAFICA ======
  return (
    <div
      style={{
        backgroundColor: "#E5E5E5",
        minHeight: "100vh",
      }}
    >
      {visualizzaPagina ? (
        <Grid>
          <InfoUserAdmin />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Paper elevation={10} className="paperStyle">
              {/* Header come le altre (senza tabs, ma stessa fascia) */}
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  p: 2,
                  fontWeight: 600,
                }}
              >
                Nuovo abbonamento (Operatore)
              </Box>

              <div style={{ padding: 20, minHeight: "75vh" }}>
                {/* DATI UTENTE */}
                <Box
                  component="form"
                  sx={{ "& .MuiTextField-root": { m: 1, width: "25ch" } }}
                  noValidate
                  autoComplete="off"
                >
                  <Grid align="center">
                    <h2 style={{ padding: "8px 0" }}>
                      Informazioni nuovo utente
                    </h2>
                    <TextField
                      id="nomeTF"
                      label="Nome"
                      onChange={(e) => setNomeNuovoUtente(e.target.value)}
                    />
                    <TextField
                      id="congomeTF"
                      label="Cognome"
                      onChange={(e) => setCognomeNuovoUtente(e.target.value)}
                    />
                    <TextField
                      id="telefonoTF"
                      label="Telefono"
                      onChange={(e) => setTelefonoNuovoUtente(e.target.value)}
                    />
                    <TextField
                      id="emailTF"
                      label="Email"
                      onChange={(e) => setEmailNuovoUtente(e.target.value)}
                    />
                    <FormGroup align="center" sx={{ mt: 1 }}>
                      <FormControlLabel
                        control={<Checkbox onChange={checkContanti} />}
                        label="Contanti"
                        key={"contanti"}
                      />
                    </FormGroup>
                  </Grid>
                </Box>

                {/* CAMPO */}
                <Grid align="center">
                  <h2 style={{ padding: "16px 0" }}>Campo</h2>
                  <FormGroup>
                    {bookableField.map((item, index) => (
                      <FormControlLabel
                        key={index}
                        checked={isBookableFieldChecked(index)}
                        control={
                          <Checkbox
                            onChange={(event) =>
                              checkBookableField(event, index)
                            }
                          />
                        }
                        label={item}
                      />
                    ))}
                  </FormGroup>
                </Grid>

                {/* PERIODO */}
                <Grid align="center">
                  <FormControl>
                    <h2 style={{ padding: "16px 0" }}>Periodo</h2>
                    <RadioGroup name="radio-buttons-group">
                      <FormControlLabel
                        value={5}
                        name={"Giornaliero"}
                        control={<Radio onChange={handleChange} />}
                        label="Giornaliero"
                        sx={radioItemSx(tipoAbbonamento === "Giornaliero")}
                      />
                      <FormControlLabel
                        value={10}
                        name={"Mensile"}
                        control={<Radio onChange={handleChange} />}
                        label="Mensile"
                        sx={radioItemSx(tipoAbbonamento === "Mensile")}
                      />
                      <FormControlLabel
                        value={25}
                        name={"Trimestrale"}
                        control={<Radio onChange={handleChange} />}
                        label="Trimestrale"
                        sx={radioItemSx(tipoAbbonamento === "Trimestrale")}
                      />
                      <FormControlLabel
                        value={90}
                        name={"Annuale"}
                        control={<Radio onChange={handleChange} />}
                        label="Annuale"
                        sx={radioItemSx(tipoAbbonamento === "Annuale")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {/* CALENDARIO */}
                <Grid align="center">
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale={"it"}
                  >
                    <h2 style={{ padding: "16px 0" }}>Calendario</h2>
                    <Stack spacing={3} sx={{ width: "100%" }}>
                      {DatePickerAnno && (
                        <DatePicker
                          views={["year"]}
                          label="Anno"
                          minDate={dayjs(dayjs())}
                          value={valueData}
                          onChange={setValueData}
                          renderInput={(params) => (
                            <TextField {...params} helperText={null} />
                          )}
                        />
                      )}
                      {DatePickerMese && (
                        <DatePicker
                          views={["year", "month"]}
                          label="Anno e mese di inizio"
                          minDate={dayjs(dayjs())}
                          value={valueData}
                          onChange={setValueData}
                          renderInput={(params) => (
                            <TextField {...params} helperText={null} />
                          )}
                        />
                      )}
                      {DatePickerGiorno && (
                        <DatePicker
                          views={["day"]}
                          label="Data"
                          minDate={dayjs(dayjs())}
                          value={valueData}
                          onChange={setValueData}
                          renderInput={(params) => (
                            <TextField {...params} helperText={null} />
                          )}
                        />
                      )}
                    </Stack>
                  </LocalizationProvider>
                </Grid>

                {/* TOTALE + CTA */}
                <Grid align="center" sx={{ mt: 2 }}>
                  <h2 style={{ padding: "8px 0" }}>
                    Totale: {Number(num) * Number(costoAbbonamento)} €
                  </h2>
                  <Button
                    disabled={isClickableButton ? false : true}
                    variant="contained"
                    size="medium"
                    fullWidth
                    onClick={buttonCLickPagamento}
                    sx={{ mt: 2 }}
                  >
                    Scegli piano
                  </Button>
                </Grid>

                {/* ALERTS */}
                {alertError ? (
                  <Alert sx={{ mt: 2 }} severity="error">
                    {msgAlert}
                  </Alert>
                ) : null}
                {alertOk ? (
                  <Alert sx={{ mt: 2 }} severity="success">
                    {msgAlert}
                  </Alert>
                ) : null}
              </div>
            </Paper>
          </div>
        </Grid>
      ) : null}
    </div>
  );
};

// stile coerente con le altre pagine per i radio della durata
function radioItemSx(active) {
  return {
    m: 1,
    width: { xs: "100%", sm: 360 },
    height: "56px",
    border: "1px solid #5E2367",
    borderRadius: 2,
    bgcolor: active ? "#5E236730" : "transparent",
  };
}

export default NuovoAbbonamentoDaOperatore;
